// pages/Terms.js
import React from "react";
import { Box, Container, Typography, Link, Paper } from "@mui/material";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms of Service – SortlyBooks</title>
      </Helmet>
      <Navbar />
      <Box sx={{ height: { xs: 72, md: 72 } }} />{" "}
      {/* Spacer for fixed navbar */}
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper
          elevation={0}
          sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, backgroundColor: "#fff" }}
        >
          <Typography variant="h4" gutterBottom>
            Terms of Service
          </Typography>

          <Typography variant="body2" paragraph>
            <strong>Effective Date:</strong> May 12, 2025
          </Typography>

          <Typography variant="body1" paragraph>
            By using SortlyBooks, you agree to the following terms and
            conditions. Please read them carefully.
          </Typography>

          <Typography variant="h6" gutterBottom>
            1. Use of Service
          </Typography>
          <Typography variant="body1" paragraph>
            SortlyBooks is intended for freelancers and small business users to
            manage receipts and generate reports. You must be at least 16 years
            old to use the service.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. Account Security
          </Typography>
          <Typography variant="body1" paragraph>
            You are responsible for maintaining the confidentiality of your
            login credentials. We are not liable for any unauthorized access to
            your account.
          </Typography>

          <Typography variant="h6" gutterBottom>
            3. Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to suspend or terminate accounts for misuse,
            abuse, or violation of these terms.
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. Liability
          </Typography>
          <Typography variant="body1" paragraph>
            SortlyBooks is provided “as is”. We make no warranties regarding
            uptime, data retention, or third-party integrations.
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. Contact
          </Typography>
          <Typography variant="body1" paragraph>
            For any questions about these terms, please contact{" "}
            <Link href="mailto:support@sortlybooks.com">
              support@sortlybooks.com
            </Link>
            .
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Data & Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            We collect and store your data in accordance with our{" "}
            <Link href="/privacy" underline="hover">
              Privacy Policy
            </Link>
            . By using SortlyBooks, you consent to the collection, use, and
            storage of your information as described therein.
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. Subscription & Billing
          </Typography>
          <Typography variant="body1" paragraph>
            If you subscribe to a paid plan, you authorize us to charge your
            selected payment method. Subscriptions renew automatically unless
            canceled. Refunds are handled on a case-by-case basis.
          </Typography>

          <Typography variant="h6" gutterBottom>
            8. Changes to These Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may update these Terms of Service occasionally. When we do, we
            will revise the "Effective Date" above. Continued use of the service
            constitutes acceptance of the updated terms.
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
